var modChangePass = function(){
	var scope = ".js-mod-change-pass";
	ui.ready(
        scope,
		function($mod){
		    var $changePassForm = $mod.find(scope+"__form");
            $changePassForm.submit(
                function(ev){
					ev.preventDefault();
					var $button = $changePassForm.find(scope+"__button");
                    var isOk = $changePassForm.checkRestrictions();
                    if(isOk){
                        $button.prop("disabled",true);
                        gvf.endpoint(
                        	"web\\webUserPrivateController::changePass",
                            [$changePassForm.getValues()],
                            function(response){
                                $button.prop("disabled",false);
                                if(response.status=="ok"){
                                    window.location = response.url;
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }
                }
            );
		}
	);
}();

